import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function CookieConsent() {
  const [dismissed, setDismissed] = useState(() => localStorage.getItem("cookie_consent") === "accepted");

  if (dismissed) return null;

  const accept = () => {
    localStorage.setItem("cookie_consent", "accepted");
    setDismissed(true);
  };

  return (
    <div style={{
      position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 10000,
      background: "#14532d", color: "white", padding: "14px 20px",
      display: "flex", alignItems: "center", justifyContent: "center", gap: "16px",
      flexWrap: "wrap", boxShadow: "0 -2px 12px rgba(0,0,0,0.15)"
    }}>
      <span style={{ fontSize: "13px", maxWidth: "640px" }}>
        We use only strictly necessary cookies to keep you signed in — no advertising or tracking cookies.{" "}
        <Link to="/privacy-policy" style={{ color: "#bbf7d0", textDecoration: "underline" }}>Privacy Policy</Link>
      </span>
      <button onClick={accept}
        style={{ background: "#16a34a", color: "white", border: "none", borderRadius: "8px", padding: "8px 20px", fontSize: "13px", fontWeight: "700", cursor: "pointer", whiteSpace: "nowrap" }}>
        Got it
      </button>
    </div>
  );
}
